<template>
  <div>
    <!-- TABELA DE LOGOS -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Logos</h3>
          <div class="card-tools">
            <!-- PAGINAÇÃO  -->
            <ul class="pagination pagination-sm m-0 float-right">
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

              <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                <a
                  :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                  class="page-link"
                  href="#"
                  @click="selecionarPagina(pagina)"
                >
                  {{ pagina }}
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
              </li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
            </ul>
          </div>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th>Imagem</th>
                <th>Nome</th>
                <th>Data criação</th>
                <th>Editar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(logo, index) in logos" :key="logo">
                <td data-label="Imagem"><img width="90px" height="50px" :src="getImagePath(logo)" /></td>
                <td data-label="Nome">{{ logo.nome }}</td>

                <td data-label="Data criação">{{ formatDate(logo.created_at) }}</td>

                <td>
                  <a :href="getUrlEdit(logo)" type="button" class="btn btn-primary btn-sm">Editar</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + logos.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 150px"></div>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: [],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      logo_selecionado: "",
      filtro: "",
      paginas: [],
      logos: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome: "",
      estado: "",
      cidade: "",
      cidades: "",
      cpf_cnpj: "",
      endereco: "",
      email: "",
      fone: "",
      nome_contato: "",
      max_page: 0,
    };
  },

  mounted() {
    console.log(this.logos);
    this.buscarlogos();
  },

  methods: {
    getImagePath(logo) {
      if (logo.path.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + logo.path + "/" + logo.arquivo;
      } else if (logo.path.includes("rochaleiloes") || logo.arquivo.includes("banner_")) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + logo.path + "/" + logo.arquivo;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
      }
    },

    getUrlEdit(logo) {
      return "/admin/logo/" + logo.id;
    },

    show(logo) {
      this.logo_selecionado = logo;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarlogos();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarlogos();
      }
    },

    buscarlogos() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      axios
        .post(`/admin/logo/search`, data)
        .then((response) => {
          this.logos = response.data.logos;
          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);
      console.log("Max = " + this.max_page);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarlogos();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
